<template>
<div class="center">
<div class="content">
      <div class="p1">
        <img src="../assets/img/s-back.png" alt="">
      </div>
      <div class="p2">
        <img src="../assets/img/s-back.png" alt="">
      </div>
      <div class="p3">
        <img src="../assets/img/s-back.png" alt="">
      </div>
      <div class="p4">
        <img src="../assets/img/s-back.png" alt="">
      </div>
      <div class="p5">
        <img src="../assets/img/s-back.png" alt="">
      </div>
      <!-- 会员管理产品 -->
      <div class="con c_con" style="margin-bottom: 0.52rem;">
        <div class="con_a lbox1">
        </div>
        <div class="con_b lbox2">
          <p style="margin-bottom:0.312rem; font-size: 1.456rem;">慧客-会员管理产品</p>
        </div>
        <div class="con_c">
          <div style="width: 12%; white-space:nowrap;line-height: 1.664rem;font-size: 0.832rem;">
            <p>为商业项⽬提供专属企鹅智慧⼩程序，涵盖会员管理、积分管理、</p>
            <p>商城管理、卡券管理、活动管理、营销管理、资讯管理、停车管理、</p>
            <p>消息通知管理在内的全系列智慧零售管理平台；并与线下商业管理</p>
            <p>系统进⾏集成。</p>
            <!-- <p>为商业项⽬提供专属企鹅智慧⼩程序，涵盖会员管理、积分管理、商城管理、卡券管理、活动管理、营销管理、资讯管理、停车管理、消息通知管理在内的全系列智慧零售管理平台；并与线下商业管理系统进⾏集成。</p> -->
          </div>
        </div>
        <div  style="margin-top: 4.472rem;width: 100%;">
          <img  src="../assets/img/cp01.png" alt="" style="width: 100%;">
        </div>
      </div>
      <!-- <div class="clear"></div> -->
      <!-- 线上销售产品 -->
      <div class="con c_con cp2">
        <div style="float: right;">
          <div class="con_a lbox1" style="width: 8%; float: right;">
          </div>
          <div class="con_b lbox2" style="width: 34.75%; float: right;">
            <p style="margin-bottom:0.312rem; font-size: 1.456rem;">慧客-线上销售产品</p>
          </div>
          <div class="con_c" style="margin: 3.12rem 0 1.56rem 0;">
            <div style="text-align: right; white-space:nowrap;line-height: 1.664rem;font-size: 0.832rem;">
              <p>为商业项目提供专属B2B2C线上销售购物平台，不影响商户正常现有交易流程</p>
              <p>实现多级管理并形成交易闭环。</p>
              <!-- <p>为商业项⽬提供专属企鹅智慧⼩程序，涵盖会员管理、积分管理、商城管理、卡券管理、活动管理、营销管理、资讯管理、停车管理、消息通知管理在内的全系列智慧零售管理平台；并与线下商业管理系统进⾏集成。</p> -->
            </div>
          </div>
        </div>
        <div style="margin-top: 2.392rem; width: 100%;">
          <img style="width: 100%;" src="../assets/img/cp02.png" alt="">
        </div>
      </div>
      <!-- 媒介整合营销 -->
      <div class="con c_con cp3">
        <div class="con_a lbox1">
        </div>
        <div class="con_b lbox2">
          <p style="margin-bottom:0.312rem; font-size: 1.456rem;">慧投-媒介整合营销</p>
        </div>
        <div class="con_c">
          <div style="width: 12%; white-space:nowrap;line-height: 1.664rem;font-size: 0.832rem;">
            <p>根据企业特点量身定制 ，全年节点活动、品牌推广、活动推广，互联网营销定位、策划及推广。</p>
            <!-- <p>为商业项⽬提供专属企鹅智慧⼩程序，涵盖会员管理、积分管理、商城管理、卡券管理、活动管理、营销管理、资讯管理、停车管理、消息通知管理在内的全系列智慧零售管理平台；并与线下商业管理系统进⾏集成。</p> -->
          </div>
        </div>
        <div  style="margin-top: 2.392rem;width: 100%;">
          <img  src="../assets/img/cp03.png" alt="" style="width: 100%;">
        </div>
      </div>
      <!-- BI大数据分析 -->
      <div class="con c_con cp4">
        <div style="float: right;">
          <div class="con_a lbox1" style="width: 8%; float: right;">
          </div>
          <div class="con_b lbox2" style="width: 35.75%; float: right;">
            <p style="margin-bottom:0.312rem; font-size: 1.456rem;">慧客-BI大数据分析</p>
          </div>
          <div class="con_c" style="margin: 60px 0 30px 0;">
            <div style="text-align: right; white-space:nowrap;line-height: 1.664rem;font-size: 0.832rem;">
              <p>背靠腾讯系列产品海量用户数据库，快捷客流监控与数据洞察提升营销效率</p>
              <p>多维度数据建模营销分析更全面。</p>
              <!-- <p>为商业项⽬提供专属企鹅智慧⼩程序，涵盖会员管理、积分管理、商城管理、卡券管理、活动管理、营销管理、资讯管理、停车管理、消息通知管理在内的全系列智慧零售管理平台；并与线下商业管理系统进⾏集成。</p> -->
            </div>
          </div>
        </div>
        <div style="margin-top: 2.392rem;width: 100%;">
          <img style="width: 100%;" src="../assets/img/cp04.png" alt="">
        </div>
      </div>
      <!-- 微信内容运营 -->
      <div class="con c_con cp5">
        <div class="con_a lbox1">
        </div>
        <div class="con_b lbox2">
          <p style="margin-bottom:0.312rem; font-size: 1.456rem;">慧客-微信内容运营</p>
        </div>
        <div class="con_c">
          <div style="width: 12%; white-space:nowrap;line-height: 1.664rem;font-size: 0.832rem;">
            <p>结合商业本身进行平台基础内容搭建，涵盖内容编辑，视觉设计，线下内容采集拍摄，运营规划方案，数据分析报告</p>
            <!-- <p>为商业项⽬提供专属企鹅智慧⼩程序，涵盖会员管理、积分管理、商城管理、卡券管理、活动管理、营销管理、资讯管理、停车管理、消息通知管理在内的全系列智慧零售管理平台；并与线下商业管理系统进⾏集成。</p> -->
          </div>
        </div>
        <div style="margin-top: 2.392rem;width: 100%;">
          <img src="../assets/img/cp05.png" alt="" style="width: 100%;">
        </div>
      </div>

      <!-- 版本 -->
      <div class="edition">
          <div><img src="../assets/img/bb.png" alt=""></div>
          <div><img src="../assets/img/bb2.png" alt=""></div>
          <div><img src="../assets/img/bb3.png" alt=""></div>
          <div><img src="../assets/img/bb4.png" alt=""></div>
      </div>

    </div>
    <!-- 底部 -->
   <div class="food">
      <div class="food_t" style="20px">
        <div class="food_l">
          <p>ADRESS：</p>
          <p>陕西省西安市雁塔区雁塔南路885号西安金辉环球广场</p>
        </div>
        <div class="food_r">
          <div>联系我们：</div>
          <div><img style="width: 100%;" src="../assets/img/erm.jpg" alt=""></div>
        </div>
      </div>
      <div class="food_b" style="16px">Copyright © 2018 企鹅互动网络版权所有[官方网站]   <a style="color:#FFF;" href="https://beian.miit.gov.cn/" target="_blank">陕ICP备16018502号-2</a></div>
    </div>
</div>
</template>
<script>
export default {
  name: "center",
  data () {
    return {

    };
  }
}
</script>
<style scoped>

  html{
    font-size:1vw;
  }

.center{
    width: 100%;
   
    position: relative;
  }
.content{
  width: 100%;
  position: absolute;
}

  /* 会员管理产品  */
.c_con{
  width: 58%;
  margin: 0 21%;
}
.con{
  position: absolute;
  top: -10.4rem;
  left: 0;
  right: 0;
}
.con_a{
  height: 2px;
  background-color: #FFCE00;
}
.lbox1{
  width: 4%;
}
.lbox2{
   width: 17.5%;
}
.con_b{
  font-weight: bolder;
  white-space:nowrap;
  font-size: 1.144rem;
  line-height: 1.82rem;
  margin-top: 0.78rem;
}
.con_c{
  margin-top: 1.144rem;
  position: relative;
}
.con_c>div:nth-child(1){
  font-size: 0.728rem;
  margin-bottom: 0.52rem;
}
.con_c>div:nth-child(2){
  font-size: 0.624rem;
  line-height: 1.56rem;
  transform: scale(0.9);
  position: absolute;
  left: -1.768rem;
}
/* 线上销售产品 */
.cp2{
  margin-top: 43.472rem;
}
/* 媒介整合营销 */
.cp3{
  margin-top: 79.976rem;
}
/* BI大数据分析 */
.cp4{
  margin-top: 116.428rem;
}
/* 微信内容运营 */
.cp5{
 margin-top: 152.62rem;
}
/* 版本 */
.edition{
  width: 58%;
  margin: 0 21%;
  margin-top: 181.74rem;
  display: flex;
  justify-content: space-between;
}
.edition>div{
  width: 22%;
}
.edition>div>img{
  width: 100%;
}

.p1{
    width: 34%;
    height: 10.92rem;
    position: absolute;
    top:29.64rem;
    left: -12.012rem;
}
.p1>img{
  width: 100%;
}
.p3{
    width: 34%;
    height: 10.92rem;
    position: absolute;
    top: 101.088rem;
    left: -12.012rem;
}
.p3>img{
  width: 100%;
}
.p5{
    width: 34%;
    height: 10.92rem;
    position: absolute;
    top: 185.796rem;
    left: -8.32rem;
    z-index: -22;
}
.p5>img{
  width: 100%;
}
.p2{
    width: 34%;
    height: 17.16rem;
    position: absolute;
    top: 64.376rem;
    right: 0;
    overflow: hidden;
}
.p2>img{
  width: 100%;
  position: absolute;
  right:-11.544rem ;
}
.p4{
    width: 34%;
    height: 17.16rem;
    position: absolute;
    top: 136.76rem;
    right: 0;
    overflow: hidden;
}
.p4>img{
  width: 100%;
  position: absolute;
  right:-11.544rem ;
}


/* 底部 */
.food{
  width: 100%;
  height: 11.596rem;
  background: #333333;
  color: #FFFFFF;
  position: absolute;
  top: 218.816rem;

}
.food_t{
  /* text-align: center; */
  width: 58%;
  margin: 0 21%;
  margin-top: 1.976rem;
}
.food_t>div{
  display: inline-block;
  vertical-align: middle;
}
.food_b{
  text-align: center;
}
.food_l{
      margin-top: 1.56rem;
      line-height: 1.56rem;
}
.food_r{
  /* margin-left: 47%; */
  float: right;
}
.food_r>div{
  display: inline-block;
  vertical-align: middle;
}
.food_r>div:nth-child(2){
  width: 5.72rem;
  height: 5.72rem;
  background: #FFFFFF;
  border-radius: 10px;
}
.food_b{
  margin-top: 1.56rem;
  font-size: 0.624rem;
}
</style>



// WEBPACK FOOTER //
// src/components/center.vue